import { useState, useRef } from 'react';
import { original, rose, vaporwave, matrix } from 'react95/dist/themes';
import { BrowserRouter, Router, Routes, Route, Link, useNavigate} from "react-router-dom";
import { createGlobalStyle, ThemeProvider, createTheme} from 'styled-components';
import { usePageSwipe } from '../../Hooks/UsePageSwipe';
import { usePageEnter } from '../../Hooks/UsePageEnter';
import { Highlight2 } from '../../App';
import {
    AppBar,
  Button,
  MenuList,
  MenuListItem,
  ScrollView,
  Separator,
  Toolbar,
    Frame,
  Window,
    Handle,
    
  WindowContent,
  WindowHeader,
    TextInput,
    styleReset
} from 'react95';



const AboutPage = () => {
    const imgBox = useRef(null);
    const descBox = useRef(null);
    console.log(Highlight2)
    
    const { transitionTo } = usePageSwipe(Highlight2, '/');  // swipe up → AboutPage
    usePageEnter();

    
    
    const loadContent = (desc) => {
        descBox.current.innerHtml = desc;
    }
    
    
    const navigate = useNavigate();
    
    const handleRedirect = (dir) => {
        navigate(dir);
    };
    
    
    
    return (
            <ThemeProvider theme={rose}>
            <Window resizable className='window' style={{ display: 'block', height: '80vh', width: 'calc(90vh * (3/2))', maxWidth: "1200px"}}>
              <WindowHeader className='window-title' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span>Highlight: Boascope</span>
                <Button style={{ marginRight: '2px', width: '20px', height: '20px', padding: 0 }} onClick={() => handleRedirect('/')}>
                  <span style={{ fontWeight: 'bold', fontSize: '12px' }}>✕</span>
                </Button>
              </WindowHeader>

              <WindowContent style={{ height: 'calc(100% - 33px)', padding: 0, overflowX: 'auto', overflowY: 'hidden' }}>
                <Frame variant='well' className='footer' style={{ height: '100%', margin: 0, overflowX: 'auto', overflowY: 'hidden'}}>
                  
                <div style={{ 
                  height: '100%', 
                  overflowX: 'auto', 
                  overflowY: 'hidden',
                  display: 'flex',
                  flexDirection: 'row'
                }}>
                    <div style={{ display: 'inline-flex', flexDirection: 'row', height: '100%' }}>

                      {/* FIRST BOX — 1/3 width */}
                      <div style={{ display: 'flex', flexDirection: 'column', width: '600px', flexShrink: 0, height: '100%', borderRight: '2px solid #888' }}>
                        <div style={{ flex: 1, overflow: 'hidden' }}>
                          <img src='/images/works/3DArt/Boascope/Cover.png'
                            style={{ width: '100%', height: '60%', objectFit: 'fill', display: 'block' }}/>
                          <div style={{ padding: '8px', background: '#ab5a71', borderTop: '1px solid #888' }}>
                            <h1 style={{ color: "#ffffff", margin: 0, fontSize: '1rem' }}>Boascope</h1>
                            <h3 style={{ margin: 0, fontSize: '.8rem' }}>(2026)</h3>
                            <h2 style={{ margin: 0, fontSize: '.85rem' }}>3D Artist: Blender, Maya, Clip Studio Paint</h2>
                          </div>
                          <p style={{ whiteSpace: 'normal', fontSize: '.85em', padding: '8px', margin: 0, overflowY: 'auto', height: 'calc(60% - 80px)' }}>
                            Boascope is a 3D First Person Puzzle Game, made as a part of the 2026 PlayStation Career Pathway "Ratchet it Up" game jam. In this game you play as a mage trapped in jail for shoplifting who uses a magical borescope to escape.
                          </p>
                        </div>
                      </div>

                      {/* SECOND BOX — 1/3 width */}
                      <div style={{ display: 'flex', flexDirection: 'column', width: '400px', flexShrink: 0, height: '100%', borderRight: '2px solid #888' }}>
                        <div style={{ flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
                          <p style={{ whiteSpace: 'normal', fontSize: '.85em', padding: '8px', margin: 0, flex: 1, overflowY: 'auto', whiteSpace: 'pre-wrap'}}>
                            I joined this game early on in development working with the other Artist on the team Adis Roberts to make the 3D assets for the game. With them giving me 2D concept art to work off of and me making the models based off that. Overall we had a pretty decent flow of being able to take ideas, turn them into drawings and then into textured and rigged models. Even working around our busy schedules towards the end of the school year. 
                              <br/><br/>
                               The following highlight documents my progress working on the models for the game From Concept, refining, UV Unwraping, Texturing and Rigging
                          </p>
                          <div style={{ flexShrink: 0 }}>
                            <img src='/images/works/3DArt/Boascope/inMirror.png'
                              style={{ width: '100%', height: '250px', objectFit: 'cover', display: 'block' }}/>
                            <div style={{ padding: '6px 8px', background: '#ab5a71', borderTop: '1px solid #888' }}>
                              <p style={{ margin: 0, fontSize: '.8em', color: "#ffffff" }}>In-game screenshot</p>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* THIRD BOX — wider, 2 images top / 3 images bottom */}
                      <div style={{ display: 'flex', flexDirection: 'column', width: '1000px', flexShrink: 0, height: '100%' }}>
                        
                        {/* Top row — 2 images */}
                        <div style={{ display: 'flex', flexDirection: 'row', flex: 1, borderBottom: '2px solid #888', overflow: 'hidden' }}>
                          
                          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', borderRight: '1px solid #888', overflow: 'hidden' }}>
                            <img src='/images/works/3DArt/Boascope/mageBodyFinal.png'
                              style={{ width: '100%', flex: 1, objectFit: 'cover', display: 'block', minHeight: 0 }}/>
                            <div style={{ padding: '4px 8px', background: '#ab5a71', borderTop: '1px solid #888', flexShrink: 0 }}>
                              <p style={{ margin: 0, fontSize: '.8em', color: "#ffffff" }}>Mage Model Fully Rigged and posed in a little dance position with clothes modeled in maya with quad draw</p>
                            </div>
                          </div>

                          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                            <img src='/images/works/3DArt/Boascope/mageBodyTexturedInProgress.png'
                              style={{ width: '100%', flex: 1, objectFit: 'cover', display: 'block', minHeight: 0 }}/>
                            <div style={{ padding: '4px 8px', background: '#ab5a71', borderTop: '1px solid #888', flexShrink: 0 }}>
                              <p style={{ margin: 0, fontSize: '.8em', color: "#ffffff" }}>Unclothed and Unrigged Mage</p>
                            </div>
                          </div>

                        </div>

                        {/* Bottom row — 3 images */}
                        <div style={{ display: 'flex', flexDirection: 'row', flex: 1, overflow: 'hidden' }}>

                          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', borderRight: '1px solid #888', overflow: 'hidden' }}>
                            <img src='/images/works/3DArt/Boascope/mageInProgress.png'
                              style={{ width: '100%', flex: 1, objectFit: 'cover', display: 'block', minHeight: 0 }}/>
                            <div style={{ padding: '4px 8px', background: '#ab5a71', borderTop: '1px solid #888', flexShrink: 0 }}>
                              <p style={{ margin: 0, fontSize: '.8em', color: "#ffffff" }}>First iteration of the Mage Model in Blender. As you can see it's Very Low poly and honestly quite ugly. It took a while to get something I really liked</p>
                            </div>
                          </div>

                          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', borderRight: '1px solid #888', overflow: 'hidden' }}>
                            <img src='/images/works/3DArt/Boascope/MageRef.png'
                              style={{ width: '100%', flex: 1, objectFit: 'cover', display: 'block', minHeight: 0 }}/>
                            <div style={{ padding: '4px 8px', background: '#ab5a71', borderTop: '1px solid #888', flexShrink: 0 }}>
                              <p style={{ margin: 0, fontSize: '.8em', color: "#ffffff" }}>UV Layout for the Mage Texture Exported From Blender</p>
                            </div>
                          </div>

                          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                            <img src='/images/works/3DArt/Boascope/MageTexture.png'
                              style={{ width: '100%', flex: 1, objectFit: 'cover', display: 'block', minHeight: 0 }}/>
                            <div style={{ padding: '4px 8px', background: '#ab5a71', borderTop: '1px solid #888', flexShrink: 0 }}>
                              <p style={{ margin: 0, fontSize: '.8em', color: "#ffffff" }}>Final Mage Texture drawn over that UV Layout in Clip Studio Paint</p>
                            </div>
                          </div>

                        </div>


                      </div>
                      <div style={{ display: 'flex', flexDirection: 'column', width: '400px', flexShrink: 0, height: '100%', borderRight: '2px solid #888' }}>
                        <div style={{ flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
                          
                          <div style={{ flex: 1}}>
                            <img src='/images/works/3DArt/Boascope/idle.gif'
                              style={{ width: '100%', height: '250px', objectFit: 'cover', display: 'block' }}/>
                            <div style={{ padding: '6px 8px', background: '#ab5a71', borderTop: '1px solid #888' }}>
                              <p style={{ margin: 0, fontSize: '.8em', color: "#ffffff" }}>Idle animation Made in Maya and imported into Unity</p>
                            </div>
                          </div>
                          <div style={{ flex: 1 }}>
                            <img src='/images/works/3DArt/Boascope/HoldMirror.gif'
                              style={{ width: '100%', height: '250px', objectFit: 'cover', display: 'block' }}/>
                            <div style={{ padding: '6px 8px', background: '#ab5a71', borderTop: '1px solid #888' }}>
                              <p style={{ margin: 0, fontSize: '.8em', color: "#ffffff" }}>Holding Mirror animation made in Maya and imported into Unity</p>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div style={{ display: 'flex', flexDirection: 'column', width: '500px', flexShrink: 0, height: '100%', borderRight: '2px solid #888' }}>
                        <div style={{ flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
                          <p style={{ whiteSpace: 'normal', fontSize: '.85em', padding: '8px', margin: 0, flex: 1, overflowY: 'auto', whiteSpace: 'pre-wrap'}}>
                            Working on the mage model took most of my time the first week week. I wasn’t quite satisfied with how unrefined the model was and wanted to redo it. Character modeling, especially organic character is something I’m still yet to be fully accustomed to so with ones like these it often takes a few passes until I get it completely right. After one night of trying many, MANY passes I eventually reached this result. This result came after starting the model from the face first. With a much less detailed iteration of the face to begin with. I decided to keep it low detail and not fully model the face since we didn’t really need facial animations. Which does make for a model that somewhat looks like a mii but overall we feel it works for the aesthetic of the game. Then I went down and modeled the chest, arms, and legs. After I created the texture by adding a few seam loops around the arms, legs, neck and feet to control the UV unwrapping and then I unwrapped the UV map into a template I could use to draw the textures on like what is shown above. After coloring it in, it looked like this, to the left. <br/><br/>With the hair I used a blender geometry nodes system I created a while back to generate curls on the hair curves object. I would send you a screenshot of the final, modified node tree but Blender deletes the node tree once you apply it and turn it into a mesh. Something I did in order to make the hair visible in Maya and Unity. So I'll just explain it instead. Essentially, it just applies a sine wave along a series of resampled curve control points, increases the frequency for more curliness and uses cosine to render it in a third dimension. With a float curve determining how large the loops get. Then using a primitive circle as the profile of the geometry. Then for the hat I just made a cone, subdivided it a few times. Then I create a spiral curve for the snake on the hat, scale it, extrude it, add geometry to it, and then convert it into a mesh. Then I joined the geometry of the hat and the snake. <br/><br/>After having the body put together I imported the meshes into maya to work on the clothes. I started by using quad draw to retopologize the mesh. I started by creating a low poly loop around the neck. WIth a loop similar to the one demonstrated in this tutorial pictured to the left. Then mirroring it like so. Then I continued extruding with quad draw along the outer edges to create an upper shirt look. Followed by extruding along the arm to create a new loop for the arm to extrude along.Then linking it to the back and the front of the robe. Then dragging down the middle of the robe to make v neck to it. Then to continue extruding the bottom of the robe to reach their legs. I then scaled the quadraw mesh and converted it to a surface mesh. Then I subdivided it and extruded it inward to make the robe a little more solid and add thickness. Then I add a few more subdivisions to make it deform properly and then we have the clothes mesh. I then apply a purple material and add a smoothing on it to make this. Then In order to add animations to the model I used Maya’s Autorig system to create a simple rig for the model After that we were ready to animate

                          </p>
                          
                        </div>
                      </div>

                      <div style={{ display: 'flex', flexDirection: 'column', width: '1000px', flexShrink: 0, height: '100%' }}>
                        
                        {/* Top row — 2 images */}
                        <div style={{ display: 'flex', flexDirection: 'row', flex: 1, borderBottom: '2px solid #888', overflow: 'hidden' }}>
                          
                          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', borderRight: '1px solid #888', overflow: 'hidden' }}>
                            <img src='/images/works/3DArt/Boascope/fullSnakeTextured.png'
                              style={{ width: '100%', flex: 1, objectFit: 'cover', display: 'block', minHeight: 0 }}/>
                            <div style={{ padding: '4px 8px', background: '#ab5a71', borderTop: '1px solid #888', flexShrink: 0 }}>
                              <p style={{ margin: 0, fontSize: '.8em', color: "#ffffff" }}>Full Boascope Model in Blender with the body sequenced a long a curve modifier to preview how it'd look in game with the head</p>
                            </div>
                          </div>

                          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                            <img src='/images/works/3DArt/Boascope/SnakeTextured.png'
                              style={{ width: '100%', flex: 1, objectFit: 'cover', display: 'block', minHeight: 0 }}/>
                            <div style={{ padding: '4px 8px', background: '#ab5a71', borderTop: '1px solid #888', flexShrink: 0 }}>
                              <p style={{ margin: 0, fontSize: '.8em', color: "#ffffff" }}>Snake Body without the head, textured in Blender</p>
                            </div>
                          </div>

                        </div>

                        {/* Bottom row — 3 images */}
                        <div style={{ display: 'flex', flexDirection: 'row', flex: 1, overflow: 'hidden' }}>

                          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', borderRight: '1px solid #888', overflow: 'hidden' }}>
                            <img src='/images/works/3DArt/Boascope/snakeInProgress.png'
                              style={{ width: '100%', flex: 1, objectFit: 'cover', display: 'block', minHeight: 0 }}/>
                            <div style={{ padding: '4px 8px', background: '#ab5a71', borderTop: '1px solid #888', flexShrink: 0 }}>
                              <p style={{ margin: 0, fontSize: '.8em', color: "#ffffff" }}>Snake body sequenced in Blender with a curve modifier to preview how it'd look in game</p>
                            </div>
                          </div>

                          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', borderRight: '1px solid #888', overflow: 'hidden' }}>
                            <img src='/images/works/3DArt/Boascope/snakeHeadInProgress.png'
                              style={{ width: '100%', flex: 1, objectFit: 'cover', display: 'block', minHeight: 0 }}/>
                            <div style={{ padding: '4px 8px', background: '#ab5a71', borderTop: '1px solid #888', flexShrink: 0 }}>
                              <p style={{ margin: 0, fontSize: '.8em', color: "#ffffff" }}>Untextured Snake Head</p>
                            </div>
                          </div>

                          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                            <img src='/images/works/3DArt/Boascope/SnakeHeadTexture.png'
                              style={{ width: '100%', flex: 1, objectFit: 'cover', display: 'block', minHeight: 0 }}/>
                            <div style={{ padding: '4px 8px', background: '#ab5a71', borderTop: '1px solid #888', flexShrink: 0 }}>
                              <p style={{ margin: 0, fontSize: '.8em', color: "#ffffff" }}>Snake Head Texture painted in Clip Studio Paint</p>
                            </div>
                          </div>

                        </div>


                      </div>
                      <div style={{ display: 'flex', flexDirection: 'column', width: '400px', flexShrink: 0, height: '100%', borderRight: '2px solid #888' }}>
                        <div style={{ flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
                          <p style={{ whiteSpace: 'normal', fontSize: '.85em', padding: '8px', margin: 0, flex: 1, overflowY: 'auto', whiteSpace: 'pre-wrap'}}>
                          After the Mage model I started to texture the boascope head and body model. Again trying the same method of adding seams to the model, unwrapping the UVs, creating a layout and then coloring it in with Clip Studio Pro. Before reimporting it into Blender. The end result were these two images <br/><br/>I also did the same for the snake head texture. Resulting in these two images. This resulted in a snake that looked like the images to the left


                          </p>
                          
                        </div>
                        <div style={{ flexShrink: 0 }}>
                            <img src='/images/works/3DArt/Boascope/BoascopeBodyRef.png'
                              style={{ width: '100%', height: '250px', objectFit: 'cover', display: 'block' }}/>
                            <div style={{ padding: '6px 8px', background: '#ab5a71', borderTop: '1px solid #888' }}>
                              <p style={{ margin: 0, fontSize: '.8em', color: "#ffffff" }}>Snake Body UV layout for referencing</p>
                          </div>
                        </div>
                        <div style={{ flexShrink: 0 }}>
                            <img src='/images/works/3DArt/Boascope/SnakeHeadRef.png'
                              style={{ width: '100%', height: '250px', objectFit: 'cover', display: 'block' }}/>
                            <div style={{ padding: '6px 8px', background: '#ab5a71', borderTop: '1px solid #888' }}>
                              <p style={{ margin: 0, fontSize: '.8em', color: "#ffffff" }}>Snake Head UV Layout for referencing</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </Frame>
              </WindowContent>
            </Window>
          
          
    </ThemeProvider>
  );
}

export default AboutPage;
